document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.article-recommendations').forEach(function (section) {
    var track = section.querySelector('[data-ar-track]');
    var prevBtn = section.querySelector('[data-ar-prev]');
    var nextBtn = section.querySelector('[data-ar-next]');

    if (!track || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = track.querySelector('.product-card');
      if (!card) return track.offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    }

    function updateButtons() {
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons);

    var resizeObserver = new ResizeObserver(function () {
      updateButtons();
    });
    resizeObserver.observe(track);

    updateButtons();
  });
});
